import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LeaveLinkAccessData {
  message: string;
}

@Component({
    selector: 'app-leavelinkaccess-dialog',
    template: `
    <app-dialog
      title="Leavelink"
      ariaLabel="New tab opened dialog"
      [width]="500"
      [showActions]="true"
      [showConfirm]="true"
      [showCancel]="false"
      confirmLabel="OK"
      [showHeader]="true"
      ariaLabelMessage="Close feature not available dialog"
      (confirmEvent)="onConfirm()"
    >
      <div class="tw-py-4">
        {{ data.message }}
      </div>
    </app-dialog>
  `,
    styles: [],
    standalone: false
})
export class LeaveLinkAccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LeaveLinkAccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LeaveLinkAccessData
  ) {}

  onConfirm() {
    this.dialogRef.close();
  }
}
